import { Controller } from "@hotwired/stimulus";

// Keeps list feedback in the same Turbo Frame as the records, for the land
// register and the owner index alike. The filter form remains mounted, so a
// failed request loses none of the administrator's current field, operator, or
// value.
export default class extends Controller {
  static targets = ["errorTemplate", "form", "frame", "loadingTemplate"];
  static values = { delay: { type: Number, default: 200 } };

  disconnect() {
    window.clearTimeout(this.loadingTimer);
  }

  loading() {
    window.clearTimeout(this.loadingTimer);
    this.frameTarget.setAttribute("aria-busy", "true");
    this.loadingTimer = window.setTimeout(() => {
      this.frameTarget.innerHTML = this.loadingTemplateTarget.innerHTML;
    }, this.delayValue);
  }

  loaded() {
    window.clearTimeout(this.loadingTimer);
    this.frameTarget.removeAttribute("aria-busy");
  }

  error(event) {
    event.preventDefault();
    window.clearTimeout(this.loadingTimer);
    this.frameTarget.removeAttribute("aria-busy");
    this.frameTarget.innerHTML = this.errorTemplateTarget.innerHTML;
  }

  retry() {
    this.formTarget.requestSubmit();
  }
}
